import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export const SectionBox = ({ id, background, py = { xs: 18, md: 20 }, pt, pb, role, children, }) => {
    return (_jsx(Box, { component: "section", id: id, role: role, sx: {
            ...(pt !== undefined || pb !== undefined
                ? { pt: pt, pb: pb }
                : { py }),
            background,
        }, children: children }));
};
